import Spinner from '@CS/assets/loader.svg?react';
import { Loader as Gif } from '@CS/assets';
import CSS from './Loader.module.css';

export type LoaderProps = {
  image?: string | true;
  opacity?: number;
  color?: string;
  size?: number;
};

export const Loader = ({
  color = 'white',
  opacity = 0.0,
  size = 50,
  image
}: LoaderProps) => (
  <aside
    className={CSS.loaderContainer}
    style={{ backgroundColor: `rgb(0 0 0 / ${opacity})` }}
  >
    {image ? (
      <div className={CSS.imageContainer} style={{ width: `${size}px` }}>
        <img src={(image === true && Gif) || (image as string)} />
      </div>
    ) : (
      <div
        style={{ height: `${size}px`, width: `${size}px`, color }}
        className={CSS.spinnerContainer}
      >
        <Spinner />
      </div>
    )}
  </aside>
);
